import {authAxios} from "../utils";
import {AttachmentFileYeuCau, ticketsListURL} from "../constants";
import Cookies from 'universal-cookie';
const cookies = new Cookies();

export const Upload_Ticket_File = (ticket_id, file_attach) => {
    var FormData = require('form-data');
    var data = new FormData();
    for (const file in file_attach) {
        data.append('att_file', file_attach[file].originFileObj);
    }
    data.append('ticket_id', ticket_id);
    let config = {
        headers: {
            "Content-Type": "multipart/form-data",
        }
    };
    return authAxios(cookies.get('token'))
        .post(AttachmentFileYeuCau, data, config);
};

export const Upload_Ticket_File_Modal = (ticket_id, file_attach) => {
    var FormData = require('form-data');
    var data = new FormData();
    data.append('att_file', file_attach);
    data.append('ticket_id', ticket_id);
    let config = {
        headers: {
            "Content-Type": "multipart/form-data",
        }
    };
    return authAxios(cookies.get('token'))
        .post(AttachmentFileYeuCau, data, config)

};
// export const fetchUserInfo = () => {
//     return authAxios
//         .get(userIDURL)
//
// };
export const fetchTicketListAPI = (data) => {
    return authAxios(cookies.get('token'))
        .get(ticketsListURL, {params: {page: data.current, page_size: data.page_size,columnSort:'id',typeSort: 'ascend'}})
}


export const fetchListStatusAPI = () => {
    let res = {data : [{id:1,name:"Mới"},{id:2,name:"Đã duyệt"}]}
    return res
}

